module.exports = __webpack_public_path__ + "img/MEDIO AMBIENTE.8da3b377.gif";